import { PrismicRichText } from "@prismicio/react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from 'react';

export const RichContent = (props) => {

    const sc = props.slice.primary;

    const co = props.context.data;

    const button = props.slice.items;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    const components = {
        label: ({ children }) => (
          <sup>{children}</sup>
        ),
    }

    return (
        <section className={"bg-white " + (sc.theme) + " py-12 md:" + (space)}>
            <div className="wrapper flex flex-col-reverse md:flex-row justify-between gap-8 md:gap-24">
                <div className="pr w-full md:w-3/5">
                <PrismicRichText field={sc.content.richText} components={components} />
                    
                    {button.map((btn, index) => {
                        if (btn.button_link == null) {
                            return ""
                        }
                        return <Link key={index} to={btn.button_link.url} className={"btn text-base mt-12 pr-8 pl-5 bg-" + (btn.button_color)}>{btn.label}</Link>
                    })}
                </div>
                <div className="md:p-hero mb-6 md:mb-0 md:w-1/3 bg-person self-start rounded-3xl">
                    <GatsbyImage image={getImage(co.meta_image)} className="rounded-3xl shadow-2xl self-end" alt={co.meta_image.alt ? co.meta_image.alt : co.title.text} />
                </div>
                
            </div>
        </section>
    );
}

